/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Fade from 'react-reveal/Fade';
import { useTranslation } from "react-i18next";

import Maps from '../../static/images/fix/map.svg'
import { TitleOne, TextBodyOne, BorderText } from '../../components/text'
import westInactive from '../../static/images/maps/inactive/jakarta-barat.svg'
import southInactive from '../../static/images/maps/inactive/jakarta-seletan.svg'
import eastInactive from '../../static/images/maps/inactive/jakarta-timur.svg'
import northInactive from '../../static/images/maps/inactive/jakarta-utara.svg'
import centerInactive from '../../static/images/maps/inactive/jakarta-pusat.svg'
import westactive from '../../static/images/maps/active/jakarta-barat.svg'
import southactive from '../../static/images/maps/active/jakarta-selatan.svg'
import eastactive from '../../static/images/maps/active/jakarta-timur.svg'
import northactive from '../../static/images/maps/active/jakarta-utara.svg'
import centeractive from '../../static/images/maps/active/jakarta-pusat.svg'
import { Style } from './map.styles'

const MapFix = () => {
  const { t } = useTranslation();

  return (
    <Style id="map-fix">
      <Grid className="grid-margin">
        <Row center="lg">
          <Col sm={12} xs={12} lg={8} className="column-bottom">
            <TitleOne display="block" align="center">
              {t('pageServiceAcJakarta.part24')}
            </TitleOne>
            <div className="top-margin">
              <TextBodyOne display="block" align="center">
                {t('pageServiceAcJakarta.part25')}
              </TextBodyOne>
            </div>
            <div className="display-content">
              <Fade left>
                <BorderText background="linear-gradient(86deg, #ff8270, #e3eff9)"></BorderText>
              </Fade>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12} sm={12} xs={12}>
            <div className="image-map">
              <div className="container-map">
                <img style={{ opacity: 0 }} src={Maps} alt="halojasa/maps" />
                <div className="text-north text-map">
                  <span>{t('pageServiceAcJakarta.part26')}</span>
                  <span>{t('pageServiceAcJakarta.part27')}</span>
                </div>
                <div className="north">
                  <img src={northInactive} alt="halojasa.north-inactive" />
                  <img src={northactive} alt="halojasa/north-active" />
                </div>
                <div className="text-east text-map">
                  <span>{t('pageServiceAcJakarta.part28')}</span>
                  <span>{t('pageServiceAcJakarta.part29')}</span>
                </div>
                <div className="east">
                  <img src={eastInactive} alt="halojasa/east-inactive" />
                  <img src={eastactive} alt="halojasa/east-active" />
                </div>
                <div className="text-west text-map">
                  <span>{t('pageServiceAcJakarta.part30')}</span>
                  <span>{t('pageServiceAcJakarta.part31')}</span>
                </div>
                <div className="west">
                  <img src={westInactive} alt="halojasa/west-inactive" />
                  <img src={westactive} alt="halojasa/west-active" />
                </div>
                <div className="text-center text-map">
                  <span>{t('pageServiceAcJakarta.part32')}</span>
                  <span>{t('pageServiceAcJakarta.part33')}</span>
                </div>
                <div className="center">
                  <img src={centerInactive} alt="halojasa/center-inactive" />
                  <img src={centeractive} alt="halojasa/center-active" />
                </div>
                <div className="text-south text-map">
                  <span>{t('pageServiceAcJakarta.part34')}</span>
                  <span>{t('pageServiceAcJakarta.part35')}</span>
                </div>
                <div className="south">
                  <img src={southInactive} alt="halojasa/south-inactive" />
                  <img src={southactive} alt="halojasa/south-active" />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default MapFix
